// Widget Studio — page-observations list (CHG-2471 / ITER-905213, S5).
//
// Read-only, list-only (append-only telemetry; no detail). Config in
// @generated/screens/widget-page-observation-list, regenerated from
// widget-page-observation.entity-hint.yaml. Route /channels/widgets/observations.

import { ListPage } from "../components/composition";
import { widgetPageObservationListConfig } from "../generated/screens/widget-page-observation-list";

export function WidgetObservations() {
  return <ListPage config={widgetPageObservationListConfig} />;
}
